import { Typography } from '@mui/material'
import MostReadCard from './MostReadCard'
import { Divider, MostReadContainer } from './styled'

const MostReadSection = ({ posts }: { posts: IPost[] }) => {
  return (
    <div>
      <Typography variant="h6">Most Read</Typography>
      <Divider />
      <MostReadContainer>
        {posts.map((post, index) => (
          <MostReadCard post={post} position={index} key={post.id} />
        ))}
      </MostReadContainer>
    </div>
  )
}

export default MostReadSection
